import { config } from "./config.js";
import { features } from "./features.js";
import Model from "./Model.js";
import EngineController from "../../../shared/controller/EngineController.js";
import PathConnector from "../../../shared/js/utils/PathConnector.js";
import Dom from "../../../shared/js/utils/Dom.js";

window.iamPathConnector = PathConnector;
window.iamDom = Dom;

const model = new Model(
	config.panel,
	config.pluses,
	config.categories,
	config.engines,
	config.cart,
	config.finder,
	config.navigation,
);

document.addEventListener("alpine:init", () => {
	Alpine.store("controller", new EngineController(model, config, features));
	Alpine.store("omnicareController", {
		controller: Alpine.store("controller"),
		finder: model.finder,
		panelItems: Alpine.store("controller").panelItems,
		onSelectFinderFooterCard(foldableId) {
			const solution = this.controller.findSolution(foldableId);
			const detail = solution.children.length
				? solution.children[0]
				: solution.item;
			this.controller.navigationDetailClickedAction(detail, solution);
		},
		onSelectFinderCard(card) {
			const detail = this.controller.panelItems.value.find(
				(item) => item.id == card.panelItemId,
			);
			this.controller.setSelectedDetail(detail);
		},
		onHoverFinderCard(element) {
			if (element) {
				const detail = this.panelItems.value.find(
					(item) => item.id == element.panelItemId,
				);
				this.controller.hoveredDetail.value = detail;
			} else {
				this.controller.hoveredDetail.value = {};
			}
		},
	});
});
